<template>
  <section :id="sectionId">
    <template v-if="isStep1">
      <BaseButton container-class="play" @click:button="goToStep2">
        {{ $_translations.value.page_get_started_button_get_started }}
      </BaseButton>
    </template>
    <template v-else>
      <BaseButton container-class="play" @click:button="goToRegistration">
        {{ $_translations.value.page_get_started_button_register }}
      </BaseButton>
      <BaseButton container-default-class="" button-class="login_btn" @click:button="goToLogin">
        {{ $_translations.value.page_get_started_button_login }}
      </BaseButton>

      <p class="disclaimer">{{ $_translations.value.page_get_started_disclaimer }}</p>
    </template>
  </section>
</template>

<script setup>
import BaseButton from '@/components/button/BaseButton.vue';

defineProps({
  isStep1: {
    type: Boolean,
    required: true,
  },
  sectionId: {
    type: String,
    default: 'btns_sect',
  },
});
const emit = defineEmits(['goToStep2', 'goToLogin', 'goToRegistration']);

const goToStep2 = () => {
  emit('goToStep2');
};

const goToLogin = () => {
  emit('goToLogin');
};

const goToRegistration = () => {
  emit('goToRegistration');
};
</script>
